<template>
<div class="c-date-picker">
	<!-- 预设日期按钮 -->
	<div v-if="defaultBtn" class="header-default-date">
		<div class="header-default-date-item"
			 :class="{'header-default-date-item-selected':item.startDay==currentDate[0]&&item.endDay==currentDate[1]}"
			 v-for="(item,index) in dateList"
			 :key="index"
			 @click="pickDate([item.startDay,item.endDay])">{{item.type}}
		</div>
	</div>
	<!-- 日期选择 -->
	<date-picker :value="currentDate"
				 type="daterange"
				 :placement="placement"
				 placeholder="选择日期"
				 style="width: 200px"
                 :clearable="false"
				 @on-change="pickDate" />
</div>
</template>
<script>
import mixins from '@/mixins/index.js';
export default {
    name: 'cDatePicker',
    mixins: [mixins],
    props: {
        startDay: {
            type: String
        },
        endDay: {
            type: String
        },
        defaultBtn: {
            type: Boolean,
            default: true
        },
        placement: {
            type: String,
            default: 'bottom-end'
        },
        //预设日期
        defaultDate: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            //当前日期
            currentDate: [this.startDay, this.endDay],
            dateList: this.defaultDate
        };
    },
    mounted() {
        if (!this.dateList.length) {
            this.dateList = [
                {
                    type: '今天',
                    startDay: this.mixinGetDate('today'),
                    endDay: this.mixinGetDate('today')
                },
                {
                    type: '昨天',
                    startDay: this.mixinGetDate('yesterday'),
                    endDay: this.mixinGetDate('yesterday')
                },
                {
                    type: '近一周',
                    startDay: this.mixinGetDate('week'),
                    endDay: this.mixinGetDate('yesterday')
                }
            ];
        }
    },
    methods: {
        /*
         * @description 日期选择
         * @param date:array[string] 日期范围数组
         * @param index:string or number 预设日期选项索引
         */
        pickDate(date) {
            //如果请求时间和重复则不执行 or 为空也不执行
            if ((this.currentDate[0] == date[0] && this.currentDate[1] == date[1]) || !date[0]) return;
            this.currentDate = [...date];
            this.$emit('update:startDay', date[0]);
            this.$emit('update:endDay', date[1]);
            this.$emit('change', this.currentDate);
        }
    }
};
</script>
<style>
.c-date-picker {
    display: flex;
    flex: 0 0 auto;
    flex-wrap: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/cDatePicker.vue